import {
  createRouter,
  createWebHistory,
  type NavigationGuardNext,
  type RouteLocationNormalized
} from 'vue-router'
import { routes } from '@/routes/routerMap'
import { checkRoles, isEmptyObject, logOut } from '@/utils'
import { useAuthStore } from '@/stores/authStore.ts'
import { getAuthInfo, getUserInfo, logout } from '@/apis/userInfoService.ts'
import { RouterName } from '@/routes/config.ts'
import { useGlobalStore } from '@/stores/globalStore.ts'

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(
  async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    if (from) {
    }
    if (to.meta.title) {
      document.title = typeof to.meta.title === 'string' ? to.meta.title : 'Quản lý mạng lưới'
    }

    if (to.name === RouterName.LOGIN) {
      return next()
    }
    const { auth } = useAuthStore()

    const { isAuthentication } = auth

    // Lấy thông tin user
    const authStore = useAuthStore()
    const globalStore = useGlobalStore()

    if (!isAuthentication) {
      globalStore.setLoading(true)

      try {
        const res = await getAuthInfo()
        if (res?.accessToken) {
          authStore.setAccessToken(res.accessToken)
          authStore.setMqttToken(res.mqttToken)
          authStore.setRefreshToken(res.refreshToken)
          authStore.setMemberCompanyId(res.memberCompanyId)
          authStore.setMemberCompanyCode(res.memberCompanyCode)
          const rs = await getUserInfo()
          authStore.setUserInfo(rs.body)
          authStore.setShowModalChangePassword(rs?.body?.rqrChangePwd || false)
          authStore.setIsAuthentication(true)
        } else {
          await logout()
          logOut()
        }
      } catch (e) {
        console.log(e)
      } finally {
        globalStore.setLoading(false)
      }
    }

    const {
      auth: { userInfo }
    } = useAuthStore()

    if (to.name === 'welcome' || to.name === 'error') {
      next()
    }

    if (userInfo?.email && !userInfo?.authorization.length) {
      next('/403')
    } else {
      if (to?.meta?.uriRole && !isEmptyObject(userInfo)) {
        if (checkRoles(to?.meta?.uriRole as string)) {
          next()
        }
        next('/403')
      } else {
        next()
      }
    }
  }
)

export default router
